import { MOBILE_WIDTH } from 'datastake-daf/src/constants/Style';
import styled from 'styled-components'

export const Styles = styled.div`
  .ant-statistic-content {
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    .ant-statistic-content-prefix {
      display: flex;
    }
  }

  .ant-table-expanded-row-fixed {
    padding: var(--size) 0px;
  }
`;
